export default __webpack_public_path__ + "static/media/tux2.b8be3f4d.png";